// extracted by mini-css-extract-plugin
module.exports = {"button":"CustomModal_button__d2uzH","modal":"CustomModal_modal__PEge_","close":"CustomModal_close__esZ3B"};